<template>
    <div style="padding-top:30px;">
        <div class="page-titles p-3 border-bottom">
            <h3 class="text-themecolor">{{trans('user.user')}} 
                <span class="card-subtitle" v-if="user.profile">{{user.profile.first_name+' '+user.profile.last_name}} ({{user.email}})</span>
              <button class="btn btn-info btn-sm pull-right" @click="$router.push('/account/users/general-partners')"><i class="fas fa-list"></i> <span class="d-none d-sm-inline">General Partners</span></button>
            </h3>
        </div>
        <div class="container-fluid p-0" style="font-size: 0.75em;">
            <div class="row">
                <div class="col-12 col-sm-8">
                    <div class="card">
                        <div class="card-body p-4">
                            <div class="row">
                                <user-sidebar menu="notes" :id="id"></user-sidebar>
                                <div class="col-9 col-sm-9 pta-content-notes">
                                    <h4 class="card-title">Notes
                                      <button class="btn btn-info btn-sm pull-right m-r-10" v-if="!showCreatePanel && hasPermission('create-user')" @click="showCreatePanel = !showCreatePanel"><i class="fas fa-plus"></i> <span class="d-none d-sm-inline">Add Note</span></button>
                                    </h4>
                                  <transition name="fade" v-if="hasPermission('create-user')">
                                    <div class="card border-bottom" v-if="showCreatePanel">
                                      <div class="card-body p-4" style="background:#efefef;">
                                        <!-- <h4 class="card-title">{{trans('user.add_new_user')}}</h4> -->
                                        <form @submit.prevent="submit" @keydown="userNoteForm.errors.clear($event.target.name)" autocomplete="off">
                                          <div class="row">
                                            <div class="col-12 col-sm-12">
                                              <div class="row">
                                                <div class="col-12">
                                                  <div class="form-group">
                                                    <label for="">Note</label>
                                                    <autosize-textarea placeholder="" v-model="userNoteForm.text" rows="2" name="text"></autosize-textarea>
                                                    <show-error :form-name="userNoteForm" prop-name="text"></show-error>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <button type="submit" class="btn btn-info waves-effect waves-light pull-right">{{trans('general.add')}}</button>
                                          <button type="button" class="btn btn-danger waves-effect waves-light pull-right m-r-10" @click="showCreatePanel = !showCreatePanel">{{trans('general.cancel')}}</button>
                                        </form>
                                      </div>
                                    </div>
                                  </transition>
                                  <div class="card" v-if="user_notes.total">
                                    <div class="card-body" style="padding:0;">
                                      <div class="table-responsive" v-if="hasPermission('list-user') && user_notes.total">
                                        <table class="table table-hover">
                                          <thead>
                                          <tr>
                                            <th scope="col" v-if="!note.pd_id">{{trans('note.text')}}</th>
                                            <th scope="col" class="table-option"></th>
                                          </tr>
                                          </thead>
                                          <tbody>
                                          <tr v-for="note in user_notes.data">
                                            <td v-if="!note.pd_id">
                                              <span style="display:block;margin-bottom:5px;font-size:12px;line-height:18px;" v-if="note.creator_user">created by {{ note.creator_user.profile.first_name }} on {{ note.created_at | moment }}</span>
                                              <span style="display:block;margin-bottom:5px;font-size:12px;line-height:18px;" v-if="!note.creator_user">created by {{ note.creator_user_name }} on {{ note.created_at | moment }}</span>
                                              <span v-html="convertNl2Br(note.text)"></span>
                                            </td>
                                            <td v-if="note.pd_id">
                                              <span style="display:block;margin-bottom:5px;font-size:12px;line-height:18px;" v-if="note.creator_user">created by {{ note.creator_user.profile.first_name }} on {{ note.created_at | moment }}</span>
                                              <span style="display:block;margin-bottom:5px;font-size:12px;line-height:18px;" v-if="!note.creator_user">created by {{ note.creator_user_name }} on {{ note.created_at | moment }}</span>
                                              <span v-html="note.text"></span>
                                            </td>
                                            <td class="table-option">
                                              <div class="btn-group">
                                                <button class="btn btn-danger btn-sm" :key="note.id" v-if="hasPermission('delete-user')" v-confirm="{ok: confirmDelete(note)}" v-tooltip="'Remove note'"><i class="fas fa-trash"></i></button>
                                              </div>
                                            </td>
                                          </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                  <div v-else>No notes available.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <user-summary :user="user"></user-summary>
            </div>
        </div>
    </div>
</template>

<script>
    import userSidebar from './general-partner-sidebar'
    import userSummary from './summary'
    import vSelect from 'vue-multiselect'
    import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
    import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
    import autosizeTextarea from '../../components/autosize-textarea'
    import {v4 as uuidv4} from "uuid";
    import fileUploadInput from '../../components/file-upload-input'

    export default {
        components : { userSidebar,userSummary,vSelect, VueCtkDateTimePicker, autosizeTextarea,fileUploadInput },
        data() {
            return {
              id:this.$route.params.id,
              user:'',
              note:'',
              showCreatePanel:false,
              user_notes: {
                total: 0,
                data: []
              },
              userNoteForm: new Form({
                user_id: '',
                title: '',
                text: ''
              },true),
            };
        },
        mounted(){
            if(!helper.hasPermission('edit-user')){
                helper.notAccessibleMsg();
                this.$router.push('/home');
            }

          axios.get('/api/user/'+this.id)
              .then(response => response.data)
              .then(response => {
                this.user = response.user;
              })
              .catch(error => {
                helper.showDataErrorMsg(error);
                this.$router.push('/user/general-partners');
              });

          this.getUserNotes();

        },
        methods: {
          confirmDelete(note){
            return dialog => this.deleteNote(note);
          },
          deleteNote(note){
            axios.delete('/api/user-note/'+note.id)
                .then(response => response.data)
                .then(response => {
                  toastr.success(response.message);
                  this.getUserNotes();
                }).catch(error => {
              helper.showDataErrorMsg(error);
            });
          },
          getUserNotes(){
            axios.get('/api/user-notes/'+this.id)
                .then(response => response.data)
                .then(response => {
                  this.user_notes = response;
                })
                .catch(error => {
                  helper.showDataErrorMsg(error)
                });
          },
          submit(){
              this.userNoteForm.user_id         = this.id;
              this.userNoteForm.post('/api/user-note')
                  .then(response => {
                    toastr.success(response.message);
                    this.note = '';
                    this.getUserNotes();
                    this.is_sended = false;
                  })
                  .catch(error => {
                    helper.showErrorMsg(error);
                    this.is_sended = false;
                  });
          },
          hasPermission(permission){
            return helper.hasPermission(permission);
          },
          convertNl2Br(value) {
            if (!value) return '';
            return value.replace(/\n/g, '<br>');
          }
        },
      filters: {
        moment(date) {
          return helper.formatDateTime(date);
        }
      }
    }
</script>
